interface SelectCreferenceCanClickInput {
  disabled: boolean;
  hasInternalClickAction: boolean;
  isActionPending: boolean;
  isLoading: boolean;
  isUnresolved: boolean;
  onClick?: () => void;
}

export function selectCreferenceCanClick({
  disabled,
  hasInternalClickAction,
  isActionPending,
  isLoading,
  isUnresolved,
  onClick,
}: SelectCreferenceCanClickInput): boolean {
  const hasClickAction = Boolean(onClick) || hasInternalClickAction;
  return [
    !disabled,
    !isLoading,
    !isUnresolved,
    !isActionPending,
    hasClickAction,
  ].every(Boolean);
}
